<div class="activate-transports-dialog">

  <div class="dialog-layout">

    <h2 class="dialog-h2">
      {{'activate transports' | translate: ['tmc.activate-transports-dialog.dialog.title' ,
      translationService.language]}}
    </h2>
    <i class="horizontal-divider"></i>

    <div class="dialog-content">

      <sc-flex [vertical]="true" [fitHeight]="true" [stretchContent]="true">
        <div class="row">
          <mat-radio-group [(ngModel)]="selectedType" (change)="selectedTypeChanged($event)">
            <mat-radio-button value="{{queryType.NOT_RELEVANT}}">{{'not relevant' | translate:
              ['tmc.activate-transports-dialog.option.not-relevant', translationService.language]}}
            </mat-radio-button>
            <mat-radio-button class="margin-left" value="{{queryType.DELETED}}">{{'deleted' | translate:
              ['tmc.activate-transports-dialog.option.deleted', translationService.language]}}</mat-radio-button>
          </mat-radio-group>

          <mat-form-field class="search-field margin-left">
            <input matInput [(ngModel)]="data.query" [ngModelOptions]="{standalone: true}"
              placeholder="{{'query' | translate: ['tmc.activate-transports-dialog.query', translationService.language]}}">
          </mat-form-field>

          <button mat-stroked-button class="margin-left" (click)="performSearch()">
            {{'Search' | translate: ['tmc.activate-transports-dialog.query', translationService.language]}}
          </button>
        </div>

        <sc-content-spacer [vertical]="true"></sc-content-spacer>

        <div class="table-container">


          <table mat-table class="mat-table-selection" [dataSource]="dataSource">

            <!-- Displays a "no data" row when no rows are available. Prevents the table from looking nasty-->
            <ng-container matColumnDef="noRecord">
              <td class="no-record" [colSpan]="this.columnsToDisplay.length" mat-footer-cell *matFooterCellDef>
                {{'no data available' | translate: ['shared.tmc-table.nodata', translationService.language]}}
              </td>
            </ng-container>

            <ng-container matColumnDef="selection">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let transport">
                <mat-checkbox disabled="true" [(ngModel)]="transport.selected"></mat-checkbox>
              </td>
            </ng-container>

            <ng-container matColumnDef="planningDate">
              <th mat-header-cell *matHeaderCellDef>
                {{'planningDate'| translate:['tmc-yard.entity.transport.masterdata.planningDate',
                translationService.language]}}
              </th>
              <td mat-cell class="text-selection" *matCellDef="let transport"> {{transport.planningDate}} </td>
            </ng-container>

            <ng-container matColumnDef="carrier">
              <th mat-header-cell *matHeaderCellDef>
                {{'carrier'| translate:['tmc-yard.entity.transport.masterdata.carrier', translationService.language]}}</th>
              <td mat-cell class="text-selection" *matCellDef="let transport"> {{transport.carrier}} </td>
            </ng-container>

            <ng-container matColumnDef="identifier">
              <th mat-header-cell *matHeaderCellDef>
                {{'identifier'| translate:['tmc-yard.entity.transport.masterdata.numberPlate',
                translationService.language]}}
              </th>
              <td mat-cell class="text-selection" *matCellDef="let transport"> {{transport.identifier}} </td>
            </ng-container>

            <ng-container matColumnDef="string2">
              <th mat-header-cell *matHeaderCellDef>
                {{'string2'| translate:['tmc-yard.entity.transport.masterdata.string2', translationService.language]}}</th>
              <td mat-cell class="text-selection" *matCellDef="let transport"> {{transport.string2}} </td>
            </ng-container>

            <ng-container matColumnDef="registrationCode">
              <th mat-header-cell *matHeaderCellDef>
                {{'registrationCode'| translate:['tmc-yard.entity.transport.masterdata.registrationCode',
                translationService.language]}}
              </th>
              <td mat-cell class="text-selection" *matCellDef="let transport"> {{transport.registrationCode}} </td>
            </ng-container>

            <ng-container matColumnDef="options">
              <th mat-header-cell *matHeaderCellDef>
                {{'options'| translate:['tmc-yard.entity.transport.options', translationService.language]}}</th>
              <td mat-cell class="multiple-lines text-selection" *matCellDef="let transport"> {{transport.options}}
              </td>
            </ng-container>

            <ng-container matColumnDef="cargo">
              <th mat-header-cell *matHeaderCellDef>
                {{'cargo'| translate:['tmc-yard.entity.transport.cargo', translationService.language]}}</th>
              <td mat-cell class="multiple-lines text-selection" *matCellDef="let transport"> {{transport.cargo}}
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>

            <tr mat-row *matRowDef="let transport; columns: columnsToDisplay" [attr.data-transport-id]="transport.id" [ngClass]="{'selected': transport.selected}"
              (click)="toggleSelection(transport)"></tr>

            <tr [class.hide]="!showNoData()" mat-footer-row *matFooterRowDef="['noRecord']"></tr>
          </table>
        </div>
      </sc-flex>

    </div>

    <i class="horizontal-divider"></i>
    <div class="messages">
      <app-service-response [responseMessages]="responseMessages"></app-service-response>
    </div>

    <sc-actionbar>
      <sc-content-spacer [grow]="true"></sc-content-spacer>
      <button mat-stroked-button (click)="closeDialog()">{{'cancel' | translate:['tmc-yard.action.cancel',
        translationService.language]}}</button>
      <sc-content-spacer></sc-content-spacer>
      <button mat-flat-button class="confirm-button" [disabled]="!isActivateTransportsEnabled()"
        (click)="activateTransports()">
        <ng-container *ngIf="selectedType === queryType.NOT_RELEVANT">
          {{'activate transport' | translate: ['tmc.activate-transports-dialog.action.activate-not-relevant',
          translationService.language]}}
        </ng-container>
        <ng-container *ngIf="selectedType === queryType.DELETED">
          {{'activate transport' | translate: ['tmc.activate-transports-dialog.action.activate-deleted',
          translationService.language]}}
        </ng-container>
      </button>
    </sc-actionbar>
  </div>
</div>
